/**
 * @file customer-tin.ts
 * @module app/modules/customers/customer-tin
 * @description Customer TIN entry rule shared by Add customer and the customer profile edit:
 *   digits only, exactly 9 (e.g. 123456789) or blank. Same rule as the server (Util.validateTIN).
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 2.1.1
 * @version 2.1.1
 */

export const TIN_LENGTH = 9;

export const TIN_ERROR = "TIN must be exactly 9 digits, e.g. 123456789";

/** What the TIN field keeps while typing or pasting: digits only, at most 9 ("123-456-789" -> "123456789"). */
export const tinInput = (value: string | null | undefined): string =>
  String(value ?? "")
    .replace(/\D/g, "")
    .slice(0, TIN_LENGTH);

/** Blank, or exactly 9 digits. */
export const isValidTin = (value: string | null | undefined): boolean => {
  const v = String(value ?? "").trim();
  return v === "" || new RegExp(`^\\d{${TIN_LENGTH}}$`).test(v);
};
